<div mat-dialog-title>
  <div class="d-flex justify-content-between">
    <div class="flex-grow-1 d-flex align-items-center justify-content-center text-md">
      <span>{{'table' | translate}}:&nbsp;{{data.$storage.order.printData.variables.TABLE_NO}}</span>
      <span class="px-1">|</span>
      <span>{{appService.translate('split_check_name', {v: data.check.number})}}</span>
    </div>
    <button mat-icon-button (click)="cancel()" class="dialog-close-button">
      <mat-icon aria-label="Close Dialog">close</mat-icon>
    </button>
  </div>
</div>


<div mat-dialog-content style="position:relative; min-height:170px;">
  <table class="table">

    <tr>
      <th class="w-100">{{'PO.REMAINED_PAY' | translate}}</th>
      <th class="no-wrap" style="text-align:right;">{{data.check.$$balanceDue | lcurrency}}</th>
    </tr>

    <tr><td colspan="2"><hr /></td></tr>

    @if (data.check.totals.discounts?.order) {
      <tr class="text-highlight">
        <td class="w-100">{{'PO.ORDER_DISCOUNT' | translate}}</td>
        <td class="no-wrap" style="text-align:right;">{{(data.check.totals.discounts.order * -1) | lamount}}</td>
      </tr>
    }
    @for (offer of data.check.offers; track offer) {
      @if (offer.price) {
        <tr>
          <td class="w-100">{{offer.name}}</td>
          <td class="no-wrap" style="text-align:right;">{{offer.price | lcurrency}}</td>
        </tr>
        @if (offer.$$rewards) {
          <tr class="_small text-highlight">
            <td class="w-100"><div class="ps-3">{{'PO.ITEM_DISCOUNT' | translate}}</div></td>
            <td class="no-wrap" style="text-align:right;">{{offer.$$rewards | lcurrency}}</td>
          </tr>
        }
      }
    }

    <tr><td colspan="2"><hr /></td></tr>
    @if (appService.region == 'US') {
      <tr>
        <td class="w-100">{{'Subtotal' | translate}}</td>
        <td class="no-wrap" style="text-align:right;">{{data.check.totals.netSales | lamount}}</td>
      </tr>
      @if (data.check.$$fees) {
        <tr>
          <td class="w-100">{{'Fees' | translate}}</td>
          <td class="no-wrap" style="text-align:right;">{{data.check.$$fees | lamount}}</td>
        </tr>
      }
      @if (data.check.totals.totalServiceCharge) {
        <tr>
          <td class="w-100">{{'Service charge' | translate}}</td>
          <td class="no-wrap" style="text-align:right;">{{data.check.totals.totalServiceCharge | lamount}}</td>
        </tr>
      }
      <tr>
        <td class="w-100">{{'Tax total' | translate}}</td>
        <td class="no-wrap" style="text-align:right;">{{data.check.totals.totalExcludedTax | lamount}}</td>
      </tr>
    }
    @if (data.check.$$tip) {
      <tr>
        <td class="w-100">{{'gratuity' | translate}}</td>
        <td class="no-wrap" style="text-align:right;">{{data.check.$$tip | lamount}}</td>
      </tr>
    }
    <tr>
      <td class="w-100">{{'PO.CHECK_TOTAL' | translate}}</td>
      <td class="no-wrap" style="text-align:right;">{{data.check.totals.totalAmount | lamount}}</td>
    </tr>
    @if (data.check.$$paid) {
      <tr>
        <td class="w-100">{{'PO.PAID' | translate}}</td>
        <td class="no-wrap" style="text-align:right;">{{data.check.$$paid | lcurrency}}</td>
      </tr>
    }


  </table>
</div>

@if (data.check.$$balanceDue) {
  <div class="text-center">
    <button mat-raised-button color="accent" class="lg main-continue-btn mt-2" type="button" (click)="apply('partial')" style="min-width:240px">
      <div class="_inner" style="justify-content:center">
        <div>{{'pay' | translate}}</div>
      </div>
    </button>
  </div>
}
